import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import Icon, { IconData } from '@vds-core/icons';
import { colors } from '@vds-core/theme';
import UNSAFE_SetEnvRef from '@uie/set-env-ref';
var propTypes = {
  /**
   * @ignore
   * Style config object to configure position, states, etc of the button
   */
  styleConfig: PropTypes.object,

  /**
   * @ignore
   * The close button is fixed at the top of the dialog, not part of scroll content
   */
  fixedCloseButton: PropTypes.bool
};
var CloseButton = /*#__PURE__*/styled.button.attrs({
  'data-testid': 'modal-close-button',
  role: 'button',
  tabIndex: 0
}).withConfig({
  displayName: "CloseButton",
  componentId: "sc-xk14bb-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: ", " !important;\n  border: 0;\n  overflow: visible;\n  padding: 0;\n  position: absolute;\n  z-index: 1;\n  right: ", ";\n  top: ", ";\n\n  ", ";\n\n  &:hover,\n  &:visited {\n    cursor: pointer;\n    outline: none;\n    -webkit-appearence: none;\n    outline: 0 !important;\n  }\n\n  ", ";\n\n  ", ";\n"])), function (_ref) {
  var styleConfig = _ref.styleConfig;
  return styleConfig && styleConfig.backgroundColor ? styleConfig.backgroundColor : 'transparent';
}, function (_ref2) {
  var styleConfig = _ref2.styleConfig;
  return styleConfig && styleConfig.right ? styleConfig.right : calculateRem(16);
}, function (_ref3) {
  var styleConfig = _ref3.styleConfig;
  return styleConfig && styleConfig.top ? styleConfig.top : calculateRem(16);
}, function (_ref4) {
  var styleConfig = _ref4.styleConfig;
  return styleConfig && (styleConfig.height || styleConfig.width) && "\n  height: ".concat(styleConfig.height, ";\n  width: ").concat(styleConfig.width, ";\n  ");
}, function (_ref5) {
  var fixedCloseButton = _ref5.fixedCloseButton;
  return fixedCloseButton && "\n   z-index: 999;\n   display: flex;\n   justify-content: center;\n   align-items: center;\n   div {\n    height: ".concat(calculateRem(24), ";\n    display: block;\n   }\n   ");
}, function (_ref6) {
  var styleConfig = _ref6.styleConfig,
      inverted = _ref6.inverted;
  return styleConfig && styleConfig.interactiveStates && "\n   &:focus {\n    outline: none;\n    &:not(:active):not(:visited):not(:hover) {\n      div {\n        &:after {\n          content: \"\";\n          position: absolute;\n          height: 27px;\n          width: 27px;\n          left: 50%;\n          top: calc(50% - 1px);\n          transform: translate(-50%, -50%);\n          border:  ".concat(calculateRem(1), " dashed ").concat(inverted ? colors.white : colors.black, ";\n        }\n      }\n    }\n   }\n\n  &:active {\n    svg {\n      g {\n        path {\n          stroke: ").concat(colors.coolGray6, ";\n          stroke-width: 2px;\n        }\n      }\n    }\n  }\n\n  &:hover:not(:active) {\n    svg {\n      g {\n        path {\n          stroke-width: 2px;\n        }\n      }\n    }\n  }\n");
});
var IconWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "IconWrapper",
  componentId: "sc-xk14bb-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n"])));
/**
 * @ignore
 */

var ModalCloseButton = /*#__PURE__*/function (_Component) {
  _inherits(ModalCloseButton, _Component);

  var _super = _createSuper(ModalCloseButton);

  function ModalCloseButton(props) {
    var _this;

    _classCallCheck(this, ModalCloseButton);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "refPath", UNSAFE_SetEnvRef());

    _defineProperty(_assertThisInitialized(_this), "_removeScrollProperty", function (e) {
      var scrollView = document.getElementById("scrollbar-view-".concat(_this.props.scrollbarId));

      if (scrollView) {
        if (e.keyCode === 40) {
          scrollView.style.scrollBehavior = 'auto';
        } else if (e.keyCode === 38) {
          scrollView.style.scrollBehavior = 'auto';
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_setScrollProperty", function (offset) {
      var scrollView = document.getElementById("scrollbar-view-".concat(_this.props.scrollbarId));
      scrollView.style.scrollBehavior = 'smooth';
      scrollView.scrollTop += offset;
    });

    _defineProperty(_assertThisInitialized(_this), "_scrollDialog", function (e) {
      var scrollView = document.getElementById("scrollbar-view-".concat(_this.props.scrollbarId));
      var offset = 45;

      if (scrollView) {
        if (e.keyCode === 40) {
          _this._setScrollProperty(offset);
        } else if (e.keyCode === 38) {
          _this._setScrollProperty(-1 * offset);
        }
      }
    });

    _this.closeRef = null;
    return _this;
  }

  _createClass(ModalCloseButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.props.toggleButton && !this.props.keyPress && setTimeout(function () {
        _this2.closeRef && _this2.closeRef.blur();
      }, 0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var interactiveStates = this.props.styleConfig && this.props.styleConfig.interactiveStates;
      var iconData = this.props.styleConfig && this.props.styleConfig.iconData ? this.props.styleConfig.iconData : IconData;
      var color = this.props.inverted ? colors.white : colors.black;
      var size = this.props.styleConfig && this.props.styleConfig.size ? this.props.styleConfig.size : 'medium';
      var ariaLabel = this.props.ariaLabel ? "".concat(this.props.ariaLabel, " close") : 'Close';
      return /*#__PURE__*/React.createElement(CloseButton, _extends({
        tabIndex: 1,
        styleConfig: this.props.styleConfig,
        "aria-label": ariaLabel
      }, _defineProperty({}, this.refPath, function (elem) {
        return _this3.closeRef = elem;
      }), this.props, {
        onKeyDown: this._scrollDialog,
        onKeyUp: this._removeScrollProperty,
        inverted: this.props.inverted
      }), /*#__PURE__*/React.createElement(IconWrapper, null, /*#__PURE__*/React.createElement(Icon, {
        hasStroke: true,
        color: color,
        name: "close",
        tabIndex: -1,
        size: size,
        data: iconData
      })));
    }
  }]);

  return ModalCloseButton;
}(Component);

ModalCloseButton.propTypes = propTypes;
export default ModalCloseButton;